import { useParams } from 'react-router-dom'

import ReportViewer from './ReportViewer'

const ReportViewerWrapper = () => {
  const { workspaceId, reportId } = useParams<{ workspaceId: string; reportId: string }>()

  if (!workspaceId || !reportId) {
    return <div>Invalid parameters</div>
  }

  return <ReportViewer key={`${workspaceId}/${reportId}`} reportId={reportId} workspaceId={workspaceId} />
}

export default ReportViewerWrapper
